var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThirdPartySoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Third_party_software"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Third_party_software",
    "data-name": "Third party software",
    clipPath: "url(#clip-Third_party_software)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_36",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M58.9,44.956a4.953,4.953,0,0,0-3.744-7.573L43,31.3v-3.97h6.667a1.667,1.667,0,0,0,1.667-1.667,10,10,0,0,0-5.762-9.044A4.953,4.953,0,0,0,46.333,14a5,5,0,0,0-10,0,4.952,4.952,0,0,0,.762,2.622,10,10,0,0,0-5.762,9.044A1.667,1.667,0,0,0,33,27.333h6.667V31.3l-12.16,6.08a4.953,4.953,0,0,0-3.745,7.573A10,10,0,0,0,18,54a1.667,1.667,0,0,0,1.667,1.667H36.333A1.667,1.667,0,0,0,38,54a10,10,0,0,0-5.762-9.044,4.909,4.909,0,0,0-.531-5.946L41.333,34.2l9.626,4.813a4.908,4.908,0,0,0-.531,5.946A10,10,0,0,0,44.667,54a1.667,1.667,0,0,0,1.667,1.667H63A1.667,1.667,0,0,0,64.667,54,10,10,0,0,0,58.9,44.956ZM39.667,14a1.667,1.667,0,1,1,1.667,1.667A1.669,1.669,0,0,1,39.667,14ZM26.333,42.333A1.667,1.667,0,1,1,28,44,1.669,1.669,0,0,1,26.333,42.333Zm26.667,0A1.667,1.667,0,1,1,54.667,44,1.669,1.669,0,0,1,53,42.333Z",
    transform: "translate(10.667 2.667)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M97,5H7a5.005,5.005,0,0,0-5,5V73.333a5.005,5.005,0,0,0,5,5H36.259L33.3,85H70.7l-2.963-6.667H97a5.005,5.005,0,0,0,5-5V10a5.005,5.005,0,0,0-5-5ZM53.667,70.833a.833.833,0,0,1-.833.833H51.167a.833.833,0,0,1-.833-.833V69.167a.833.833,0,0,1,.833-.833h1.667a.833.833,0,0,1,.833.833Zm45-9.167H5.333V10A1.669,1.669,0,0,1,7,8.333H97A1.669,1.669,0,0,1,98.667,10Z",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M66,61.667H19.333a3.333,3.333,0,1,1,0-6.667H66a3.333,3.333,0,0,1,0,6.667Z",
    transform: "translate(9.333 33.333)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPartySoftware);
export default __webpack_public_path__ + "static/media/third-party-software.afe97a9ea2f0ba3d4afb55e4e114dff2.svg";
export { ForwardRef as ReactComponent };